<script>
    console.log("Loaded about")
</script>

<div class="about">
    Will come.. Working on it..
</div>


<style>
    .about {
        color: white;
    }
</style>